import { Column } from 'react-data-grid'
import Button from 'react-bootstrap/Button'
import { generatePath } from 'react-router-dom'
import styled from 'styled-components'
import { Versions } from 'domain/AppInfo'
import { VersionsColumnsConfigProps } from './types'
import { APP_ROUTES } from 'app/components/AppRouter/routes'
import { isAdmin, isTokenExpired, makeDownloadApkLink } from 'app/utils/hooks'
import check from 'assets/images/check.svg'
import minus from 'assets/images/minus.svg'

const StyledImage = styled.img`
    height: 25px;
    width: 25px;
`

export const columnsConfig = (
    props: VersionsColumnsConfigProps,
): Column<Versions>[] => {
    const { navigate } = props

    const deleteColumn: Column<Versions> = {
        key: 'apkDelete',
        name: 'Delete',
        width: 120,
        formatter: data => (
            <Button
                variant="danger"
                size="sm"
                onClick={() =>
                    props.onDeleteApk(
                        data.row.appId.toString(),
                        data.row.id.toString(),
                    )
                }>
                Delete
            </Button>
        ),
    }

    const fixedColumns = [
        {
            key: 'versionCode',
            name: 'Version Code',
            width: 120,
        },
        {
            key: 'versionName',
            name: 'Version',
        },
        {
            key: 'is32bit',
            name: '32bit',
            width: 50,
            formatter: data => {
                return <StyledImage src={data.row.is64bit ? minus : check} />
            },
        },
        {
            key: 'is64bit',
            name: '64bit',
            width: 50,
            formatter: data => {
                return <StyledImage src={data.row.is64bit ? check : minus} />
            },
        },
        {
            key: 'apkURL',
            name: 'Download',
            width: 120,
            formatter: data => (
                <Button
                    disabled={!data.row.apkUploaded}
                    variant="success"
                    size="sm"
                    onClick={() =>
                        window.open(
                            makeDownloadApkLink(
                                data.row.appId.toString(),
                                data.row.id.toString(),
                            ),
                            '_blank',
                        )
                    }>
                    Download
                </Button>
            ),
        },
        ...(isAdmin() ? [deleteColumn] : []),
    ] as Column<Versions>[]

    const optionalColumn = [
        {
            key: '',
            name: '',
            width: 45,
            formatter: data => (
                <>
                    <Button
                        size="sm"
                        variant="outline-secondary"
                        onClick={() => {
                            navigate(
                                generatePath(APP_ROUTES.EDIT_APK, {
                                    appid: data.row.appId.toString(),
                                    id: data.row.id.toString(),
                                }),
                            )
                        }}>
                        Edit
                    </Button>
                </>
            ),
        },
    ] as Column<Versions>[]

    return isTokenExpired() ? fixedColumns : optionalColumn.concat(fixedColumns)
}
